module.exports = __webpack_public_path__ + "static/media/time-icon.5b3312ee.svg";